import { render, staticRenderFns } from "./DepositoBanco.vue?vue&type=template&id=2f7a4904&"
import script from "./DepositoBanco.vue?vue&type=script&lang=js&"
export * from "./DepositoBanco.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports